import React, { useEffect } from "react";
import $ from "jquery";
import MiniProjects from "../sections/MiniProjects";
import cgHome from "../assets/img/CGhome.png";
import cgLearn from "../assets/img/CGlearn.png";
import cgArticle from "../assets/img/CGarticle.png";
import cgHomeDark from "../assets/img/CGhomeDark.png";

const Projects = () => {
  useEffect(() => {
    $(function () {
      $(".carousel-item").eq(0).addClass("active");
      var total = $(".carousel-item").length;
      var current = 0;
      $("#moveRight").on("click", function () {
        var next = current;
        current = current + 1;
        setSlide(next, current);
      });
      $("#moveLeft").on("click", function () {
        var prev = current;
        current = current - 1;
        setSlide(prev, current);
      });

      function setSlide(prev, next) {
        var slide = current;
        if (next > total - 1) {
          slide = 0;
          current = 0;
        }
        if (next < 0) {
          slide = total - 1;
          current = total - 1;
        }
        $(".carousel-item").eq(prev).removeClass("active");
        $(".carousel-item").eq(slide).addClass("active");
        setTimeout(function () {}, 800);
        console.log("current " + current);
        console.log("prev " + prev);
      }
    });
  }, []);

  var carouselArr = [
    {
      img1: cgHome,
      img2: cgLearn,
      img3: cgArticle,
      img4: cgHomeDark,
    },
  ];
  return (
    <section id="projects">
      <h1>Projects</h1>
      <h2>#Featured Projects</h2>
      {carouselArr.map((carousel) => {
        return (
          <div className="featured">
            <div class="carousel">
              <div class="carousel__nav">
                <span id="moveLeft" class="carousel__arrow">
                  <svg
                    class="carousel__icon"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"></path>
                  </svg>
                </span>
                <span id="moveRight" class="carousel__arrow">
                  <svg
                    class="carousel__icon"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"></path>
                  </svg>
                </span>
              </div>

              <div class="carousel-item carousel-item--4">
                <div
                  class="carousel-item__image"
                  style={{
                    backgroundImage: `url(${carousel.img1})`,
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                  }}
                ></div>
                <div class="carousel-item__info">
                  <div class="carousel-item__container">
                    <h1 class="carousel-item__title">Coders Gala</h1>
                    <p class="carousel-item__description">
                      Sed ut perspiciatis unde omnis iste natus error sit
                      voluptatem accusantium doloremque laudantium, totam rem
                      aperiam.
                    </p>
                    <a href="#" class="carousel-item__btn">
                      View on
                    </a>
                  </div>
                </div>
              </div>
              <div class="carousel-item carousel-item--4">
                <div
                  class="carousel-item__image"
                  style={{
                    backgroundImage: `url(${carousel.img2})`,
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                  }}
                ></div>
                <div class="carousel-item__info">
                  <div class="carousel-item__container">
                    <h1 class="carousel-item__title">Coders Gala</h1>
                    <p class="carousel-item__description">
                      Sed ut perspiciatis unde omnis iste natus error sit
                      voluptatem accusantium doloremque laudantium, totam rem
                      aperiam.
                    </p>
                    <a href="#" class="carousel-item__btn">
                      View on
                    </a>
                  </div>
                </div>
              </div>
              <div class="carousel-item carousel-item--4">
                <div
                  class="carousel-item__image"
                  style={{
                    backgroundImage: `url(${carousel.img3})`,
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                  }}
                ></div>
                <div class="carousel-item__info">
                  <div class="carousel-item__container">
                    <h1 class="carousel-item__title">Coders Gala</h1>
                    <p class="carousel-item__description">
                      Sed ut perspiciatis unde omnis iste natus error sit
                      voluptatem accusantium doloremque laudantium, totam rem
                      aperiam.
                    </p>
                    <a href="#" class="carousel-item__btn">
                      View on
                    </a>
                  </div>
                </div>
              </div>
              <div class="carousel-item carousel-item--4">
                <div
                  class="carousel-item__image"
                  style={{
                    backgroundImage: `url(${carousel.img4})`,
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                  }}
                ></div>
                <div class="carousel-item__info">
                  <div class="carousel-item__container">
                    <h1 class="carousel-item__title">Coders Gala</h1>
                    <p class="carousel-item__description">
                      Sed ut perspiciatis unde omnis iste natus error sit
                      voluptatem accusantium doloremque laudantium, totam rem
                      aperiam.
                    </p>
                    <a href="#" class="carousel-item__btn">
                      View on
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <h2>#All Projects</h2>
      <MiniProjects />
    </section>
  );
};

export default Projects;
